module.exports = __webpack_public_path__ + "img/handshake-trade-mobile.5d92660b.jpg";